// extracted by mini-css-extract-plugin
module.exports = {"monthName":"styles_monthName__28w6G","monthCards":"styles_monthCards__2OTIn"};